import type { DocForeignKeyTable } from "building-types/doc/docForeignKeyTable";
import type { PrimaryEntityId } from "building-types/doc/primaryEntityId";
import type { PartialRecord } from "common/utils/types";
import type { DocEntityBase } from "./docEntityBase";

export interface Label extends DocEntityBase<"LABEL"> {
  readonly id: PrimaryEntityId<"LABEL">;
}

export const BuiltInLabels = [
  "addToElectricalPlan",
  "addToFloorPlan",
  "addToFoundationPlan",
  "addToStructuralPlan",
  "addToShowroomPlan",
  "addToBrochurePlan",
  "addToFloorMaterialsPlan",
  "addToFloorSummaryPlan",
  "addToRoofPlan",
  "addToUtilityPlan",
  "addToExteriorElevation",
  "addToPerspectiveView", // This will determine visibility in linework perspective views. There's no effect on realistic style views, which don't have tag-based filtering.
] as const;

export type BuiltInLabel = (typeof BuiltInLabels)[number];

export interface LabelableEntityBase {
  readonly labels: DocForeignKeyTable<"LABEL", boolean>;
}

// Props like automatically placed roof brackets are subject to label-based visibility filtering,
// but historically they have not been filtered and so they don't have label information.
// Make sure they show up in views by default.
export const hardCodedAutoPlacedPropLabels: PartialRecord<BuiltInLabel, true> = {
  addToExteriorElevation: true,
  addToPerspectiveView: true,
};
